import { render } from "./CourseCadView.vue?vue&type=template&id=f56b2bfa"
import script from "./CourseCadView.vue?vue&type=script&lang=js"
export * from "./CourseCadView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__